export default __webpack_public_path__ + "c568bb5c2044890d6125cfca7cb452f4.png";